import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["form"];
    unsavedChanges = false;

    connect() {
    }

    formIsChanged() {
        this.unsavedChanges = true
    }

    allowFormSubmission() {
        this.unsavedChanges = false
    }

    warnUser(event) {
        if (this.unsavedChanges) {
            const message = "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?";
            event.returnValue = message; // Standard for most browsers
            return message; // For some older browsers
        }
    }

}
